module.exports = __webpack_public_path__ + "static/img/header_2.20417ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/header_2.png
// module id = AkdK
// module chunks = 18